import React from 'react';
import moment from 'moment';
import { IImageSettings, Image } from '@msdyn365-commerce/core';
import { ProductComponetInput } from './../coc-c-invoice-details.view';
import { IInvoiceDetailsViewProps } from '@msdyn365-commerce-modules/invoice-details/src/modules/invoice-details/./invoice-details';
import { getProductPageUrlSync, ObjectExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { ICocCInvoiceDetailsResources } from './../coc-c-invoice-details.props.autogenerated';

const _renderProductImage = (
    className: string,
    imageURL: string,
    productName: string,
    altImageURL: string,
    imageSettings?: IImageSettings,
    properties?: IInvoiceDetailsViewProps
): JSX.Element | null => {
    const defaultImageSettings: IImageSettings = {
        viewports: {
            xs: { q: 'w=315&h=315&m=6', w: 0, h: 0 },
            lg: { q: 'w=315&h=315&m=6', w: 0, h: 0 },
            xl: { q: 'w=315&h=315&m=6', w: 0, h: 0 }
        },
        lazyload: true,
        cropFocalRegion: true
    };

    if (imageSettings) {
        imageSettings.cropFocalRegion = true;
    }

    return (
        <Image
            className={className}
            altText={productName}
            title={productName}
            src={imageURL || ''}
            fallBackSrc={altImageURL}
            gridSettings={properties?.context.request.gridSettings!}
            imageSettings={imageSettings || defaultImageSettings}
            loadFailureBehavior='empty'
        />
    );
};

export const InvoiceDetailsProductDetailComponent: React.FC<{
    data: ProductComponetInput[];
    resources: ICocCInvoiceDetailsResources;
    properties: IInvoiceDetailsViewProps;
}> = (props): JSX.Element => {
    const className: string = 'msc-invoice-details__products';
    const productLineClass = `${className}__product-line`;
    const productLineInfoContainerClass = `${productLineClass}__product-info-container`;
    const productLineDetailsClass = `${productLineInfoContainerClass}__product-details`;
    const productLineSmallDetailsClass = `${productLineDetailsClass}__small-details`;
    const productLineOtherDetailsClass = `${productLineDetailsClass}__other-details`;

    return (
        <div>
            {props.data.map(productInfo => {
                const splitDate = productInfo.CreatedDate && JSON.stringify(productInfo.CreatedDate).split('T');
                const longOrderDate = splitDate && moment(splitDate[0]).format('MMMM DD, YYYY');
                //const longOrderDate = productInfo.CreatedDate && moment(productInfo.CreatedDate, 'YYYY-MM-DD').format('MMMM DD, YYYY');

                //console.log('Price', productInfo);

                let productUrl = '';
                if (
                    !ObjectExtensions.isNullOrUndefined(productInfo.productName) &&
                    !ObjectExtensions.isNullOrUndefined(productInfo.recordId)
                ) {
                    if (productInfo.primaryImageUrl === undefined) {
                        productUrl = 'javascript:void(0)';
                    } else {
                        productUrl = getProductPageUrlSync(
                            productInfo.productName,
                            productInfo.recordId,
                            props.properties.context.actionContext
                        );
                    }
                }
                return (
                    <div className={productLineClass} key={''}>
                        <div className={productLineInfoContainerClass}>
                            {_renderProductImage(
                                `${productLineInfoContainerClass}__product-image`,
                                productInfo.primaryImageUrl!,
                                productInfo.productName!,
                                productInfo.altImageUrl!,
                                props.properties.config.imageSettings,
                                props.properties
                            )}
                            <div className={productLineDetailsClass}>
                                <div className='msc-invoice-details-line-div'>
                                    <a className={`${productLineDetailsClass}__name`} href={productUrl}>
                                        {productInfo.productName}
                                    </a>
                                    <div className={`msc-invoice-details-line-item-price`}>${productInfo.productPrice}</div>
                                </div>
                                <div className={productLineSmallDetailsClass}>
                                    {
                                        <div className={`${productLineOtherDetailsClass}__address`}>
                                            {props.resources.searchKeyLabel}: {productInfo.searckKey!.replace(/\|/g, '') || 'N/A'}
                                        </div>
                                    }
                                    {
                                        <div className={`${productLineOtherDetailsClass}__folio-number`}>
                                            {props.resources.folioNumberLabel}: {productInfo.FolioNumber || 'N/A'}
                                        </div>
                                    }
                                </div>

                                <div className={productLineOtherDetailsClass}>
                                    <div className={`${productLineOtherDetailsClass}__saleOrder`}>
                                        {`${props.resources.saleOrderLabel}: `}
                                        {productInfo.SalesOrder || 'N/A'}
                                    </div>

                                    <div className={`${productLineOtherDetailsClass}__date`}>
                                        {/* @ts-ignore */}
                                        {props.resources.createdDateLabel}: {longOrderDate || 'N/A'}
                                    </div>
                                    <div className={`${productLineOtherDetailsClass}__placedBy`}>
                                        {/* @ts-ignore */}
                                        {props.resources.placedByLabel}: {productInfo.PlacedBy || 'N/A'}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
